import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { NodeProps } from 'reactflow';
import { ITaskNodeData } from 'types/flows';
import { ITheme } from 'types/theme';
import InputHandle from './ActionableNode/InputHandle';
import useHandleConnectOnly from './ActionableNode/useHandleConnectOnly';

const EndNode = ({ id }: NodeProps<ITaskNodeData>) => {
	const theme = useTheme<ITheme>();

	const [nodeRef, handleRef] = useHandleConnectOnly(id);

	return (
		<Box
			ref={nodeRef}
			p={1}
			pl={2}
			pr={2}
			data-testid={`node-${id}`}
			bgcolor={theme.palette.text.secondary}
			sx={{ width: 'fit-content' }}
			borderRadius={6}
		>
			<InputHandle
				ref={handleRef as React.MutableRefObject<HTMLDivElement | null>}
			/>
			<Typography
				variant="body1"
				color="background.paper"
				textTransform="uppercase"
			>
				{intl.tr('flows.builder.end.task.label')}
			</Typography>
		</Box>
	);
};

export default EndNode;
